/**
 * MfaStatusBadge
 *
 * Displays the current MFA status of the authenticated user.
 * Used inside the Security section of account settings.
 *
 * Epic: MVP 1.15 (V2) — Federated Auth, Epic 4: MFA
 * Story: SCRUM-356 — Guide MFA Setup
 */

import React from 'react';
import { ShieldCheck, ShieldOff } from 'lucide-react';

/**
 * @param {Object}  props
 * @param {boolean} props.mfaEnabled    - Whether MFA is currently enabled
 * @param {string|null} props.mfaMethod - Method in use: 'TOTP', 'SMS', or null
 */
export default function MfaStatusBadge({ mfaEnabled, mfaMethod }) {
  if (!mfaEnabled) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-600">
        <ShieldOff size={14} />
        MFA Disabled
      </span>
    );
  }

  const methodLabel = mfaMethod === 'SMS' ? 'SMS' : 'Authenticator';

  return (
    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-green-50 text-green-700 border border-green-200">
      <ShieldCheck size={14} />
      MFA Enabled ({methodLabel})
    </span>
  );
}
